export default "__VITE_ASSET__3ebe53f0__"